module.exports = __webpack_public_path__ + "img/sign-32.39f7addb.jpg";